import http from "./http";
import Service from "../Service";
import { BIconHandThumbsUp } from "bootstrap-vue";

/**
 * @type ClientService
 */
export default class ClientService extends Service {
    list(params) {
        return http.get(`/admin/clients`, {
            headers: this.getHeaders(),
            params
        });
    }
    listNew(params, status) {
        let url = "/admin/clients/new?";
        status.forEach(element => {
            url += "status[]=" + element + "&";
        });
        return http.get(url, {
            headers: this.getHeaders(),
            params
        });
    }

    analytic(params) {
        return http.get(`/admin/clients/analytic`, {
            headers: this.getHeaders(),
            params
        });
    }

    show(id) {
        return http.get(`/admin/clients/${id}`, {
            headers: this.getHeaders()
        });
    }

    remove(id) {
        return http.delete(`/admin/clients/${id}`, {
            headers: this.getHeaders()
        });
    }

    load_profiles(client_id) {
        return http.get(`/admin/clients/${client_id}/profiles`, {
            headers: this.getHeaders()
        });
    }

    load_stores(client_id) {
        return http.get(`/admin/clients/${client_id}/stores`, {
            headers: this.getHeaders()
        });
    }

    load_buyers(client_id, params) {
        return http.get(`/admin/clients/${client_id}/buyers`, {
            headers: this.getHeaders(),
            params
        });
    }

    load_resales() {
        return http.get(`/admin/resales`, {
            headers: this.getHeaders()
        });
    }

    load_resale(params = {}) {
        if (params.noPagination) {
            return http.get(`/admin/resales?noPagination=true`, {
                headers: this.getHeaders()
            }).then(response => {
                return response.data.data || response.data;
            });
        }
    }

    load_sectors() {
        return http.get(`/admin/clients/sectors`, {
            headers: this.getHeaders()
        });
    }

    create(client) {
        return http.post(`/admin/clients`, client, {
            headers: this.getHeaders()
        });
    }

    update(client) {
        return http.put(`/admin/clients/${client.id}`, client, {
            headers: this.getHeaders()
        });
    }

    update_attendance(client, attendance) {
        return http.put(
            `/admin/clients/${client.id}/attendances/${attendance.id}`,
            attendance,
            {
                headers: this.getHeaders()
            }
        );
    }
    getDirectSales(id) {
        return http.get("/admin/direcshopping?cli_id=" + id, {
            headers: this.getHeaders()
        });
    }
    UpdateDirectSales(user) {
        if (user.usu_id)
            return http.put("/admin/direcshopping/" + user.usu_id, user, {
                headers: this.getHeaders()
            });
        else
            return http.post("/admin/direcshopping/", user, {
                headers: this.getHeaders()
            });
    }
    getBills(id) {
        return http.get("clients/conexa/store/" + id, {
            headers: this.getHeaders()
        });
    }
    payBill(payload) {
        return http.post("external/conexa/quitacao/cobranca ", payload, {
            headers: this.getHeaders()
        });
    }
    deleteProducts(id) {
        return http.post(
            "admin/clients/products/cliente/" + id,
            {},
            {
                headers: this.getHeaders()
            }
        );
    }
    getCotList(id) {
        return http.get("admin/gestao/cotacao", {
            headers: this.getHeaders(),
            params: { cli_id: id }
        });
    }
    updateCot(payload) {
        return http.put("admin/gestao/cotacao/" + payload.id, payload, {
            headers: this.getHeaders()
        });
    }
    saveCot(payload) {
        return http.post("admin/gestao/cotacao", payload, {
            headers: this.getHeaders()
        });
    }
    updateCot(payload) {
        return http.put("admin/gestao/cotacao/" + payload.id, payload, {
            headers: this.getHeaders()
        });
    }
    getCot(id) {
        return http.get("admin/gestao/cotacao/", {
            headers: this.getHeaders(),
            params: { cot_id: id }
        });
    }

    getCurrentPackaging(clientId) {
        return http.get(`clients/${clientId}/embalagem`, {
            headers: this.getHeaders()
        });
    }

    updateClientPackaging(clientId, packaging) {
        if (!packaging || typeof packaging !== "string") {
            return Promise.reject(new Error("Embalagem deve ser uma string"));
        }

        const parts = packaging.split(" ");
        if (parts.length !== 2) {
            return Promise.reject(
                new Error('Formato inválido. Use "UN 1", "CX 12", etc.')
            );
        }

        const [unit, quantity] = parts;
        const validUnits = [
            "UN",
            "CX",
            "FD",
            "KG",
            "DZ",
            "un",
            "cx",
            "fd",
            "kg",
            "dz"
        ];

        if (!validUnits.includes(unit.toUpperCase())) {
            return Promise.reject(
                new Error("Unidade inválida. Use UN, CX, FD, KG ou DZ")
            );
        }

        if (!/^\d+$/.test(quantity) || parseInt(quantity) <= 0) {
            return Promise.reject(
                new Error("Quantidade deve ser um número positivo")
            );
        }
        const standardizedPackaging = `${unit.toUpperCase()} ${quantity}`;

        return http.post(
            `clients/${clientId}/embalagem`,
            {
                embalagem: standardizedPackaging
            },
            {
                headers: this.getHeaders()
            }
        );
    }
    zeroProrrogation(cotId) {
        return http.put(
            `admin/cotacao/${cotId}/prorrogation`,
            {
                prorrogation: 0
            },
            {
                headers: this.getHeaders()
            }
        );
    }
    getSystems() {
        return http.get("/admin/clients/sistemas" , {
            headers: this.getHeaders()
        });
    }
    reactivate(id) {
        return http.post(`/admin/clients/${id}/reactivate`, {}, {
            headers: this.getHeaders(),
        });
    }
}
